export const getMapProps = (componentData, googleMapsApiUrl) => {
    const mapEl = componentData?.fields?.elements?.find(el => el?.sys?.contentType?.sys?.id === "embedMap");

    const props = {
        placeId: mapEl?.fields?.placeId,
        embedMapProps: {
            title: componentData?.fields?.title,
            backgroundColor: componentData?.fields?.backgroundColour,
            mapOpts: {
                url: googleMapsApiUrl,
                placeId: mapEl?.fields?.placeId,
                keyword: mapEl?.fields?.keyword,
                coordinates: mapEl?.fields?.coordinates,
                width: parseInt(mapEl?.fields?.mapWidth) || undefined,
                height: parseInt(mapEl?.fields?.mapHeight) || undefined
            }
        },
        staticMapProps: {
            center: mapEl?.fields?.coordinates?.lat && mapEl?.fields?.coordinates?.lon ? `${mapEl?.fields?.coordinates?.lat}, ${mapEl?.fields?.coordinates?.lon}` : undefined,
            zoom: 13,
            width: parseInt(mapEl?.fields?.mapWidth),
            height: parseInt(mapEl?.fields?.mapHeight)
        }
    };
    return props;
};